/* ----------------------------------------------------------------------------
   LBM PREORDER DEADLINE
   締切までの残り時間を見て、案内の見た目を切り替える。
   Liquid 側で初期表示は出し終えているので、ここは補正と更新だけを行う。
   （ページキャッシュで古い状態が配信されても、読み込み時にここで正しい状態に直る）

   商品カード（data-compact）は1行表示なので、状態を直すだけで秒更新はしない。
   一覧に何十枚もカードが並ぶため、タイマーを増やさないようにしている。
   ------------------------------------------------------------------------- */

(function () {
  'use strict';

  function formatRemaining(ms) {
    var total = Math.floor(ms / 1000);
    var d = Math.floor(total / 86400);
    var h = Math.floor((total % 86400) / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;

    var parts = [];
    if (d > 0) parts.push(d + '日');
    if (d > 0 || h > 0) parts.push(h + '時間');
    parts.push(m + '分', s + '秒');

    return 'あと ' + parts.join(' ');
  }

  function stateOf(host, remaining) {
    if (remaining <= 0) return 'ended';
    var urgentMs = (parseFloat(host.dataset.urgentHours) || 24) * 3600 * 1000;
    return remaining <= urgentMs ? 'urgent' : 'upcoming';
  }

  // 商品カード用：1行のピルを書き換えるだけ
  function renderCard(host, deadline) {
    var slot = host.querySelector('[data-lbm-card]');
    if (!slot) return;

    var state = stateOf(host, deadline.getTime() - Date.now());
    host.dataset.state = state;

    slot.textContent = state === 'ended'
      ? host.dataset.endedText
      : host.dataset.shortText + ' ' + host.dataset.cardSuffix;
  }

  // 商品ページ用：締切間近ならカウントダウンする
  function renderProduct(host, deadline) {
    var remaining = deadline.getTime() - Date.now();
    var state = stateOf(host, remaining);

    var main = host.querySelector('[data-lbm-main]');
    var pill = host.querySelector('[data-lbm-pill]');
    var count = host.querySelector('[data-lbm-count]');

    host.dataset.state = state;

    if (state === 'ended') {
      if (main) main.textContent = host.dataset.endedText;
      if (pill) pill.hidden = true;
      if (count) count.hidden = true;
      return false; // これ以上の更新は不要
    }

    var urgent = state === 'urgent';
    if (pill) pill.hidden = !urgent;

    if (count) {
      count.hidden = !urgent;
      if (urgent) count.textContent = formatRemaining(remaining);
    }

    return urgent; // 締切間近のときだけ1秒ごとに更新する
  }

  function setup(host) {
    var deadline = new Date(host.dataset.deadline);
    if (isNaN(deadline.getTime())) return;

    if (host.dataset.compact) {
      renderCard(host, deadline);
      return;
    }

    if (!renderProduct(host, deadline)) return;

    var timer = setInterval(function () {
      if (!host.isConnected || !renderProduct(host, deadline)) clearInterval(timer);
    }, 1000);
  }

  function init() {
    document.querySelectorAll('lbm-preorder-deadline').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();